<p-card [header]="isEditMode ? 'Update Unit of Measure' : 'Create Unit of Measure'">
    <form [formGroup]="createUnitOfMeasureForm" style="height: 100vh;">

        <div class="col">

            <div class="field col-12 flex justify-content-between align-items-center">
                <div class="flex justify-content-start">
                    <p-button [label]="isEditMode ? 'Update' : 'Save'" icon="pi pi-save" size="small"
                        (click)="saveUnitOfMeasure(createUnitOfMeasureForm.value, isEditMode)"></p-button>

                    <p-button label="Cancel" class="p-button-outlined ml-2" icon="pi pi-times" severity="danger"
                        size="small" routerLink="/home/listUnitsOfMeasure">
                    </p-button>

                </div>

                <div>
                    <label class="block label-required" style="font-weight: bold;">Required Field</label>
                </div>
            </div>

        </div>

        <div class="card flex justify-content-end mr-2">
            <p-checkbox formControlName="isActive" [binary]="true" inputId="binary" value="isActive"
                label="Active"></p-checkbox>
        </div>
        <div class="grid">
            <div class="col">
                <div class="field text-left">
                    <label for="website" class="label-required display">UOM Code</label>
                    <input pInputText placeholder="e.g 356" [readOnly]="isEditMode" formControlName="unitsofMeasureCode"
                        (keydown)="onKeydown($event)"
                        [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.unitsofMeasureCode.errors }"
                        class="w-full p-inputtext-sm" />
                    <small *ngIf="submitted && formControls.unitsofMeasureCode.errors" id="unitsofMeasureCode-error"
                        class="text-red-500">Required
                        field.</small>
                </div>
                <div class="field text-left">
                    <label for="website" class="label-required display">Unit of measure</label>
                    <input pInputText placeholder="e.g Kg" formControlName="unitsofMeasure"
                        (keydown)="onKeydown($event)"
                        [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.unitsofMeasure.errors }"
                        class="w-full p-inputtext-sm" />
                    <small *ngIf="submitted && formControls.unitsofMeasure.errors" id="unitsofMeasure-error"
                        class="text-red-500">Required
                        field.</small>
                </div>
            </div>

            <div class="col">
                <div class="field text-left">
                    <label for="website" class="label-required display">UOM Description</label>
                    <textarea pInputText placeholder="e.g 1Kg = 1000grams" class="w-full p-inputtext-sm"
                        formControlName="unitsofMeasureDescription"
                        [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.unitsofMeasureDescription.errors }"
                        rows="6"></textarea>
                    <small *ngIf="submitted && formControls.unitsofMeasureDescription.errors"
                        id="unitsofMeasureDescription-error" class="text-red-500">Required
                        field.</small>
                </div>
            </div>
        </div>

    </form>
</p-card>

<p-toast></p-toast>